import axios from '../../utils/axios-interceptor';
import { getAPIHost } from '../../utils/helper';
import { getAccessHeader } from '../../utils/loginSession';

export const enums = {
  SET_LAYOUT: { 
    type: 'SET_LAYOUT',
    state: 'layout'
  },
};

// COMMON FETCH & SET STATE FUNCTIONS -->
export const setState = (type, state) => {
  return {
    type: type.type,
    payload: state,
  };
};

// My Performance
export const fetchLayout = () => async (dispatch, getState) => {
  let currentLocale = (localStorage.getItem('language') || "en") + "-" + (localStorage.getItem('country') || "my");
  try {
    const apiUrl = getAPIHost();
    let res = await axios({
      headers: getAccessHeader(getState()),
      method: 'GET',
      url: `${apiUrl}/layout/str/${currentLocale}`,
    });
    console.log("fetchLayout res ", res);
    if (res?.status === 200) {
      dispatch(setState(enums.SET_LAYOUT, { ...res.data }));
      return { ...res.data };
    }
  } catch (err) {
    console.log(err);
  }
};

// state
const layoutState = (state = {}, action) => {
  switch (action.type) {
    // for special case
    
    // for use enum
    default:
      if (enums[action.type]) {
        return {
          ...state,
          [enums[action.type].state]: action.payload,
        };
      }

    // for default
    return state;
  }
};

export default {
  layoutState,
};
